import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import WebhookIcon from '@mui/icons-material/Webhook';
import { ModernPageContainer } from '../components/ModernTable';
import ApiKeys from './ApiKeys';
import Webhooks from './Webhooks';

function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 3 }}>{children}</Box> : null;
}

export default function Integration() {
  const theme = useTheme();
  const [tab, setTab] = useState(0);

  return (
    <ModernPageContainer>
      <Box sx={{
        borderBottom: 1, borderColor: 'divider', mb: 1,
        bgcolor: alpha(theme.palette.background.paper, 0.8),
        borderRadius: 2, overflow: 'hidden',
        border: `1px solid ${alpha(theme.palette.divider, 0.15)}`,
      }}>
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          textColor="primary"
          indicatorColor="primary"
          sx={{ px: 2 }}
        >
          <Tab icon={<VpnKeyIcon />} iconPosition="start" label="API Keys" sx={{ minHeight: 56, fontWeight: 600 }} />
          <Tab icon={<WebhookIcon />} iconPosition="start" label="Webhooks" sx={{ minHeight: 56, fontWeight: 600 }} />
        </Tabs>
      </Box>

      <TabPanel value={tab} index={0}>
        <ApiKeys />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <Webhooks />
      </TabPanel>
    </ModernPageContainer>
  );
}
